import React, { useState, useRef } from 'react'
import { Tag, Tooltip, Input } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import { observer } from 'mobx-react-lite'
import type { FieldMethods } from '../types'

export interface TagsInputProps {
    field?: FieldMethods
    index?: number
    disabled?: boolean
    className?: string
    style?: React.CSSProperties
    [key: string]: any
}

export const TagsInput: React.FC<TagsInputProps> = observer(({ field, index }) => {
    const [inputVisible, setInputVisible] = useState(false)
    const [inputValue, setInputValue] = useState('')
    const inputRef = useRef<any>(null)

    if (!field) {
        return null
    }

    const { value: tags = [], onChange, ...props } = field.bind({ index: index ?? 0 })

    const handleClose = (removedTag: string) => {
        const newTags = tags.filter((tag: string) => tag !== removedTag)
        onChange(newTags)
    }

    const showInput = () => {
        setInputVisible(true)
        setTimeout(() => {
            if (inputRef.current) {
                inputRef.current.focus()
            }
        }, 0)
    }

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInputValue(e.target.value)
    }

    const handleInputConfirm = () => {
        let newTags = tags
        if (inputValue && tags.indexOf(inputValue) === -1) {
            newTags = [...tags, inputValue]
        }

        setInputVisible(false)
        setInputValue('')
        onChange(newTags)
    }

    const handleKeyPress = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            handleInputConfirm()
        }
    }

    return (
        <div>
            {tags.map((tag: string, tagIndex: number) => {
                const isLongTag = tag.length > 20
                const tagElem = (
                    <Tag key={tag} closable={!props.disabled} onClose={() => handleClose(tag)}>
                        {isLongTag ? `${tag.slice(0, 20)}...` : tag}
                    </Tag>
                )
                return isLongTag ? (
                    <Tooltip title={tag} key={tag}>
                        {tagElem}
                    </Tooltip>
                ) : (
                    tagElem
                )
            })}
            {inputVisible && (
                <Input
                    ref={inputRef}
                    type="text"
                    size="small"
                    style={{ width: 78 }}
                    value={inputValue}
                    onChange={handleInputChange}
                    onBlur={handleInputConfirm}
                    onPressEnter={handleKeyPress}
                />
            )}
            {!inputVisible && !props.disabled && (
                <Tag onClick={showInput} style={{ background: '#fff', borderStyle: 'dashed' }}>
                    <PlusOutlined /> New Tag
                </Tag>
            )}
        </div>
    )
})
